export const emailRegEx = /^(?!-)[\w.-]{2,}@[\w-]+(\.[\w-]+)*\.[a-zA-Z]{2,}$/u;

export const ZIPcodeRegEx = /^\d{5}(?:[-\s]\d{4})?$/;

export const passwordRegEx = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d@!#$%^&*()_+=[\]{};':"\\|,.<>/?-]{7,}$/;